import React from 'react'
import PropTypes from 'prop-types'
import {Redirect, Route} from 'react-router-dom'

export const ProtectedRoute = ({component: Component, isGrantedAccess, ...rest}) => {
  return (
    <Route {...rest} render={
      (props) => {
        if(isGrantedAccess) {
          return <Component {...props} /> 
        }
        else {
          return <Redirect to='/login' />
        } 
      }
    }
    />
  )
}

ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  isGrantedAccess: PropTypes.bool.isRequired,
  redirectTo: PropTypes.string,
}
